module.exports = __webpack_public_path__ + "img/chi-siamo-2.39bbaf5c.jpg";